export const formatPhoneNumber = ({
  franchisePhone,
}: {
  franchisePhone: string;
}): string => {
  if (!franchisePhone || franchisePhone.length !== 10) {
    console.error(
      `Invalid phone number ${franchisePhone} provided to formatPhoneNumber function`,
    );
    return "";
  }

  return franchisePhone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
};

/**
 * @deprecated Please use formatPartialPhoneNumber from @homeinstead/shared instead
 */
export function formatPartialPhoneNumber({
  franchisePhone,
}: {
  franchisePhone: string;
}): string {
  const digits = franchisePhone.replace(/\D/g, "").slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
